export { default } from './services-list.component';
